import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';
// material
import { alpha, experimentalStyled as styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { Box, AppBar, Hidden, Toolbar, IconButton, Button, Link, TextField, Typography, Grid } from '@mui/material';
import AccountPopover from './AccountPopover';
import { useState, useEffect, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import link from 'src/redux/slices/link';
// import { MBreadcrumbs } from './@material-extend';

const useStyles = makeStyles(() => ({
  navbar: {
    textDecoration: "none",
    paddingRight: 10,
    color: '#637381'
  },
  navButton: {
    color: "#637381",
    border: "1px solid #637381",
    marginLeft: 10,
    width: 95
  }
}));
// ----------------------------------------------------------------------

const DRAWER_WIDTH = 236;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 64;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  border: '1px solid #ECEFF1;',
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${DRAWER_WIDTH}px)`,
  }
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 3)
  }
}));

// ----------------------------------------------------------------------

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func
};

export default function DashboardNavbar({ onOpenSidebar }) {
  const classes = useStyles();
  const history = useHistory();
  const links = useSelector((state) => state.link.link);
  const goToPreView = () => {
    history.push(`${links[`${links.length-2}`].href}`);
  }
  return (
    <RootStyle>
      <ToolbarStyle>
        <Hidden lgUp>
          <IconButton
            onClick={onOpenSidebar}
            sx={{ mr: 1, color: 'text.primary' }}
          >
            <Icon icon={menu2Fill} />
          </IconButton>
        </Hidden>
        {
          links.length > 1 && (
            <Grid sx={{
              padding: '10px 0', 
              height: '64px', 
              width: '36px', 
              borderRight: '1px solid #ECEFF1', 
              display: 'flex', 
              alignItems: 'center', 
              marginRight: '10px',
              cursor: 'pointer'
            }}
            className="header-icon-bar"
            onClick={() => goToPreView()}
            >
              <img src="/static/icons/navbar/arrow-left.svg"/>
            </Grid>
          )
        }
        {
          links.map((li, i) => {
            return (
              li.href ? (
                <>
                  {(i != 0 && i != links.lenth-1) && (
                      <Typography sx={{color: '#78909C', fontSize: '12px', fontFamily: 'Inter'}}>&nbsp; / &nbsp;</Typography>
                  )}
                  <Link sx={{color: '#78909C', fontSize: '12px', textDecoration: 'none', fontFamily: 'Inter'}} href={li.href}>{li.name}</Link>
                </>
              ) : (
                <>
                  {(i != 0 && i != links.lenth-1) && (
                      <Typography sx={{color: '#78909C', fontSize: '12px', fontFamily: 'Inter'}}>&nbsp; / &nbsp;</Typography>
                  )}
                  <Typography sx={{color: '#78909C', fontSize: '12px', fontFamily: 'Inter'}}>{li.name}</Typography>
                </>
              )
            )
          })
        }
        {/* <MBreadcrumbs links={links}/> */}
        {/* <Searchbar /> */}
        <Box sx={{ flexGrow: 1, alignItems: 'center',  display: 'flex', justifyContent: 'center' }} >
          {/* <Button className={classes.navButton}>Manage</Button>
          <Button className={classes.navButton}>Configure</Button>
          <Button className={classes.navButton}>User Admin</Button> */}
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            '& > *:not(:first-of-type)': {
              ml: { xs: 1.5, sm: 2, lg: 3 }
            }
          }}
        >
          {/* <LanguagePopover />
          <NotificationsPopover /> */}
          {/* <a className={classes.navbar} href="/dashboard/create">Sub Accounts</a>
          <a className={classes.navbar} href="/">API Tokens</a> */}
          <AccountPopover />
        </Box>
      </ToolbarStyle>
    </RootStyle>
  );
}
